<template>
  <div class="box">
    <!-- 头部 -->
    <headers></headers>
    <el-carousel :interval="3000">
      <el-carousel-item>
        <img src="@/assets/homePage/en-banner.png" class="images">
      </el-carousel-item>
    </el-carousel>
    <!-- 内容 -->
    <div class="content">
      <div class="region">
        <h3>Recruiting Location:</h3>
        <p v-for="item in jobDate" :key="item.id">
        <p :class="['p_1', { 'p_Btn': item.id == id }]" @click="pBtn(item.id)">{{ item.name }}</p>
        <!-- <el-button type="primary" round plain> </el-button> -->
        </p>
      </div>
      <div class="job">
        <h3>Recruiting Positions:</h3>
        <div class="info" v-for="item in engineerList" :key="item.id" @click="IdBtn(item.id)">
          <div class="info_1">{{ item.name }}</div>
          <div class="info_2">
            <el-icon>
              <component :is="item.id == dataId ? 'Minus' : 'Plus'"></component>
              <!-- <Plus v-if='item.id!=dataId'/>
              <SemiSelect v-else  @click="SemiSelectBtn"/> -->
            </el-icon>
          </div>
          <div class="info_3" v-show="item.id == dataId">
            <h3>Job Responsibilities</h3>
            <p v-for="e in item.child_1" :key="e.id">{{ e.title }}</p>
            <h3>{{ item.requirement }}</h3>
            <p v-for="e in item.child_2" :key="e.id">{{ e.title }}</p>
            <h3>{{ item.recruitment }}</h3>
            <p>{{ item.headcount }}</p>
            <h3>{{ item.location }}</h3>
            <div style="width:100%;text-align: left;">
              <span v-for="(e,index) in item.locationList" :key="e.id"
                style="text-align:left;display: inline-block;margin-left: 0;">{{ index == (item.locationList.length-1) ? e.title:e.title+'、'}}</span>
            </div>
            <h3>Contact Details</h3>
            <p>{{item.Email}}</p>
            <a class="p_1" :href="email">Send your resume</a>
          </div>
        </div>

      </div>
    </div>

    <!-- 底部 -->
    <foot></foot>
  </div>
  <div class="_div">
    <!-- 头部 -->
    <move_header></move_header>
    <!-- 轮播图 -->
    <van-swipe :autoplay="3000" indicator-color="white">
      <van-swipe-item>
        <img src="@/assets/homePage/en-banner.png" class="images">
      </van-swipe-item>
    </van-swipe>
    <!-- 中间内容区域 -->
    <div class="content_center">
      <p v-for="item in jobDate" :key="item.id" @click="pBtn(item.id)" :class="[{ 'p_move': item.id == id }]">
        {{ item.name }}</p>
      <div class="info" v-for="item in engineerList" :key="item.id" @click="IdBtn(item.id)">
        <span class="span_1">{{ item.name }}</span>
        <span class="span_2">
          <el-icon>
            <component :is="item.id == dataId ? 'Minus' : 'Plus'"></component>
            <!-- <Plus v-if='item.id!=dataId'/>
                    <SemiSelect v-else  @click="SemiSelectBtn"/> -->
          </el-icon>
        </span>
        <div class="span_3" v-show="item.id == dataId">
          <h3>Job Responsibilities</h3>
          <p style="width: 100%;" v-for="e in item.child_1" :key="e.id">{{ e.title }}</p>
          <h3>{{ item.requirement }}</h3>
          <p style="width: 100%;" v-for="e in item.child_2" :key="e.id">{{ e.title }}</p>
          <h3>{{ item.recruitment }}</h3>
          <p style="text-align: center;">{{ item.headcount }}</p>
          <h3>{{ item.location }}</h3>
          <div style="width:100%;text-align: left;"> 
            <span v-for="(e,index) in item.locationList" :key="e.id"
              style="font-size: 2.8rem;">{{ index == (item.locationList.length-1) ? e.title:e.title+'、'}}</span>
          </div>
          <h3>Contact Details</h3>
           <p>{{item.Email}}</p>
          <a class="p_1" :href="email">Send your resume</a>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <move_foot></move_foot>
  </div>
</template>

<script>
import foot from '../components/foot.vue'
import headers from '../components/header.vue'
import move_foot from "../move_components/move_foot.vue";
import move_header from "../move_components/move_header.vue";
import { reactive, toRefs, watch } from 'vue'
export default {
  components: { foot, headers, move_foot, move_header },
  computed: {
    icons: function () {
      return () => {

      }
    }
  },
  setup() {

    const state = reactive({
      id: 1,
      dataId: 0,
      isIcon: 'Plus',
      email: 'mailto:shuyu.zhu@shine-optics.com',
      jobDate: [
        { id: 1, name: 'Chongqing' },
        { id: 2, name: 'Jiangxi' },
        { id: 3, name: 'Shenzhen' },
        { id: 4, name: 'India' },
      ],
      engineerList: [
        { id: 1,Email:'shuyu.zhu@shine-optics.com',name: 'Product Manager', requirement: 'Job Requirements', recruitment: 'Number of Demand', headcount: '3 people', location: "Working Address", child_1: [{ id: 1, title: "1.Lead the company's medical, AIOT, telematics and other intelligent image and lens module hardware product design according to the company's development strategy and planning." }, { id: 2, title: "2.Work scope including but not limited to meeting user/customer needs, conducting market research, competitor analysis, product planning, designing product features and other tasks." }, { id: 3, title: "3.Research, select and integrate suitable product providers, coordinate hardware development, and promote product development, testing, pilot and mass production processes in cooperation with external resources." }, { id: 4, title: "4.Control and promote the mass production related supply chain and quality management links, and solve the problems in mass production." }, { id: 5, title: "5.Research and analyze market demand and business requirements, complete the design of products, process and prototyping, as well as submit patent deliverables." }, { id: 6, title: "6.Regular tracking and analysis of competitive products in the industry, keep abreast of industry dynamics and put forward constructive product creative proposals." }, { id: 7, title: "7.Collect user opinions, continuously optimize product user experience, and develop product improvement iterative route." }], child_2: [{ id: 1, title: "1. Undergraduate degree or above, majoring in electronics-related fields, with good English skills." }, { id: 2, title: "2.More than five years of experience in any one of the product projects of vehicle-mounted /medical imaging/AIoT/smart wear/notebook computer, have led the PRD design of relevant products and have actually participated in the full life cycle management of the products." }, { id: 3, title: "3.Excellent overall quality, such as communication and coordination ability, innovation ability, data analysis ability, logical thinking ability, stress resistance ability, etc." }], locationList: [{ id: 1, title: 'Chongqing' }, { id: 2, title: 'Jiangxi' }, { id: 3, title: 'Shenzhen' }] },
        { id: 2,Email:'shuyu.zhu@shine-optics.com',name: 'Project Management', requirement: 'Job Requirements', recruitment: 'Number of Demand', headcount: '1 people', location: "Working Address", child_1: [{ id: 1, title: "1、 Leading new projects for review. " }, { id: 2, title: "2、Responsible for the progress management of project sample production." },{id:3,title:"Responsible for the production and shipping progress of samples and trial production materials to ensure that shipments are achieved."},{id:4,title:"Organize project advanced review."},{id:5,title:'Responsible for the archiving of project technical data and documentation.'},{id:6,title:"Take the lead in conducting performance appraisals for project team members."}], child_2: [{ id: 1, title: "1.Undergraduate degree, major in electronic, mechanical, automation and other related majors." }, { id: 2, title: "2.More than 2 years of PM experience in the consumer electronics industry." }, { id: 3, title: "3.Expertise in cross-departmental resource coordination and problem solving." }, { id: 4, title: '4. Proven system knowledge of project and plant management, good at process improvement.' }, { id: 5, title: '5.Experience with projects such as car camera / notebook camera / TV external camera / cell phone camera is a plus.' }], locationList: [{ id: 1, title: 'Chongqing' }] },
  // {id:4,name:'项目管理',requirement:'Job Requirements',recruitment:'Number of Demand',headcount:2,location:"Working Address",child_1:[{id:1,title:''}],child_2:[{id:1,title:''}],locationList:[{id:1,title:""}]},

      ]
    })
    watch(() => state.isIcon, (count, prevCount) => {

    })
    let methods = {
      pBtn(id) {
        state.id = id
        state.dataId = 0
        if (id == 1) {
          state.email = 'mailto:shuyu.zhu@shine-optics.com'
          state.engineerList = [
       { id: 1,Email:'shuyu.zhu@shine-optics.com',name: 'Product Manager', requirement: 'Job Requirements', recruitment: 'Number of Demand', headcount: '3 people', location: "Working Address", child_1: [{ id: 1, title: "1.Lead the company's medical, AIOT, telematics and other intelligent image and lens module hardware product design according to the company's development strategy and planning." }, { id: 2, title: "2.Work scope including but not limited to meeting user/customer needs, conducting market research, competitor analysis, product planning, designing product features and other tasks." }, { id: 3, title: "3.Research, select and integrate suitable product providers, coordinate hardware development, and promote product development, testing, pilot and mass production processes in cooperation with external resources." }, { id: 4, title: "4.Control and promote the mass production related supply chain and quality management links, and solve the problems in mass production." }, { id: 5, title: "5.Research and analyze market demand and business requirements, complete the design of products, process and prototyping, as well as submit patent deliverables." }, { id: 6, title: "6.Regular tracking and analysis of competitive products in the industry, keep abreast of industry dynamics and put forward constructive product creative proposals." }, { id: 7, title: "7.Collect user opinions, continuously optimize product user experience, and develop product improvement iterative route." }], child_2: [{ id: 1, title: "1. Undergraduate degree or above, majoring in electronics-related fields, with good English skills." }, { id: 2, title: "2.More than five years of experience in any one of the product projects of vehicle-mounted /medical imaging/AIoT/smart wear/notebook computer, have led the PRD design of relevant products and have actually participated in the full life cycle management of the products." }, { id: 3, title: "3.Excellent overall quality, such as communication and coordination ability, innovation ability, data analysis ability, logical thinking ability, stress resistance ability, etc." }], locationList: [{ id: 1, title: 'Chongqing' }, { id: 2, title: 'Jiangxi' }, { id: 3, title: 'Shenzhen' }] },
        { id: 2,Email:'shuyu.zhu@shine-optics.com',name: 'Project Management', requirement: 'Job Requirements', recruitment: 'Number of Demand', headcount: '1 people', location: "Working Address", child_1: [{ id: 1, title: "1、 Leading new projects for review. " }, { id: 2, title: "2、Responsible for the progress management of project sample production." },{id:3,title:"Responsible for the production and shipping progress of samples and trial production materials to ensure that shipments are achieved."},{id:4,title:"Organize project advanced review."},{id:5,title:'Responsible for the archiving of project technical data and documentation.'},{id:6,title:"Take the lead in conducting performance appraisals for project team members."}], child_2: [{ id: 1, title: "1.Undergraduate degree, major in electronic, mechanical, automation and other related majors." }, { id: 2, title: "2.More than 2 years of PM experience in the consumer electronics industry." }, { id: 3, title: "3.Expertise in cross-departmental resource coordination and problem solving." }, { id: 4, title: '4. Proven system knowledge of project and plant management, good at process improvement.' }, { id: 5, title: '5.Experience with projects such as car camera / notebook camera / TV external camera / cell phone camera is a plus.' }], locationList: [{ id: 1, title: 'Chongqing' }] },
 
          ]
        } else if (id == 2) {
          state.email = 'mailto:ruifang.liu@shine-optics.com'
          state.engineerList = [
            { id: 1,Email:'ruifang.liu@shine-optics.com', name: 'Product Manager', requirement: 'Job Requirements', recruitment: 'Number of Demand', headcount: '3 people', location: "Working Address", child_1: [{ id: 1, title: "1. Lead the company's medical, AIOT, telematics and other intelligent image and lens module hardware product design according to the company's development strategy and planning." }, { id: 2, title: "2.Work scope including but not limited to meeting user/customer needs, conducting market research, competitor analysis, product planning, designing product features and other tasks." }, { id: 3, title: "3.Research, select and integrate suitable product providers, coordinate hardware development, and promote product development, testing, pilot and mass production processes in cooperation with external resources." }, { id: 4, title: "4. Control and promote the mass production related supply chain and quality management links, and solve the problems in mass production." }, { id: 5, title: "5.Research and analyze market demand and business requirements, complete the design of products, process and prototyping, as well as submit patent deliverables." }, { id: 6, title: "6.Regular tracking and analysis of competitive products in the industry, keep abreast of industry dynamics and put forward constructive product creative proposals." }, { id: 7, title: "7.Collect user opinions, continuously optimize product user experience, and develop product improvement iterative route." }], child_2: [{ id: 1, title: "1.Undergraduate degree or above, majoring in electronics-related fields, with good English skills." }, { id: 2, title: "2.More than five years of experience in any one of the product projects of vehicle-mounted /medical imaging/AIoT/smart wear/notebook computer, have led the PRD design of relevant products and have actually participated in the full life cycle management of the products." }, { id: 3, title: "3.Excellent overall quality, such as communication and coordination ability, innovation ability, data analysis ability, logical thinking ability, stress resistance ability, etc.Number of Demand" }], locationList: [{ id: 1, title: 'Chongqing' }, { id: 2, title: 'Jiangxi' }, { id: 3, title: 'Shenzhen' }] },
       ]
        } else if (id == 3) {
          state.email = 'mailto:shuyu.zhu@shine-optics.com'
          state.engineerList = [
            { id: 1,Email:'shuyu.zhu@shine-optics.com', name: 'Product Manager', requirement: 'Job Requirements', recruitment: 'Number of Demand', headcount: '3 people', location: "Working Address", child_1: [{ id: 1, title: "1.Lead the company's medical, AIOT, telematics and other intelligent image and lens module hardware product design according to the company's development strategy and planning." }, { id: 2, title: "2.Work scope including but not limited to meeting user/customer needs, conducting market research, competitor analysis, product planning, designing product features and other tasks." }, { id: 3, title: "3.Research, select and integrate suitable product providers, coordinate hardware development, and promote product development, testing, pilot and mass production processes in cooperation with external resources." }, { id: 4, title: "4.Control and promote the mass production related supply chain and quality management links, and solve the problems in mass production." }, { id: 5, title: "5.Research and analyze market demand and business requirements, complete the design of products, process and prototyping, as well as submit patent deliverables." }, { id: 6, title: "6. Regular tracking and analysis of competitive products in the industry, keep abreast of industry dynamics and put forward constructive product creative proposals." }, { id: 7, title: "7.Collect user opinions, continuously optimize product user experience, and develop product improvement iterative route." }], child_2: [{ id: 1, title: "1.Undergraduate degree or above, majoring in electronics-related fields, with good English skills." }, { id: 2, title: "2.More than five years of experience in any one of the product projects of vehicle-mounted /medical imaging/AIoT/smart wear/notebook computer, have led the PRD design of relevant products and have actually participated in the full life cycle management of the products." }, { id: 3, title: "3.Excellent overall quality, such as communication and coordination ability, innovation ability, data analysis ability, logical thinking ability, stress resistance ability, etc." }], locationList: [{ id: 1, title: 'Chongqing' }, { id: 2, title: 'Jiangxi' }, { id: 3, title: 'Shenzhen' }] },

          ]
        } else if (id == 4) {
          state.engineerList = [
            { id: 1,Email:'shuyu.zhu@shine-optics.com', name: 'IE Engineer', requirement: 'Job Requirements', recruitment: 'Number of Demand', headcount: '1 people', location: "Working Address", child_1: [{ id: 1, title: '1.Responsible for the improvement of standard working hours, standard operations, value stream, production layout, operation optimization, management process optimization, etc. at production sites.' }, { id: 2, title: "2.Participate in the research and development of project efficiency and quality improvement programs, and be responsible for the implementation of related special projects." }, { id: 3, title: '3.Responsible for the preparation, optimization and implementation of production management systems and processes.' }, { id: 4, title: "4.Responsible for researching production and operation related improvement topics and participating in the design and implementation of solutions." }, { id: 5, title: '5.Obey the temporary arrangement of leadership. Job Requirements' }], child_2: [{ id: 1, title: '1.Undergraduate degree, industrial engineering related majors.' }, { id: 2, title: '2.At least one year of experience in the machining industry.' }, { id: 3, title: "3. Practical work experience in lean manufacturing, site efficiency improvement, and production operations." }, { id: 4, title: '4.Demonstrated project planning skills, organizational management skills, communication and coordination skills.' }, { id: 5, title: "5.Familiar with the application of Office/CAD and other office software, with a certain understanding of automation, equipment and fixtures." }, { id: 6, title: "6. Good English listening, speaking, reading and writing skills, able to accept the condition of working abroad." }], locationList: [{ id: 1, title: "India" }] },
          ],
          state.email = 'mailto:shuyu.zhu@shine-optics.com'
        }
      },
      IdBtn(id) {
        state.dataId = id
      },
      SemiSelectBtn() {
        state.dataId = 0
      }
    }
    return {
      ...toRefs(state), ...methods
    }
  }
}

</script>

<style scoped lang="less">
.el-carousel {
  max-width: 1920px;
  margin: 0 auto;
}

.p_1 {
  display: block;
  margin: 0 auto;
  text-indent: 0 !important;
  font-size: 20px;
  text-align: center;
  width: 350px;
  height: 42px;
  border: 1px solid #ccc;
  line-height: 42px;
  cursor: pointer;
}

.p_1:hover {
  color: #fff !important;
  background-color: #ef3e2e;
}

.p_Btn {
  color: #fff !important;
  background-color: #ef3e2e;
}

.box {
  width: 100%;

  .content {
    display: flex;
    margin: 0 auto;
    width: 70%;
    min-height: 100px;
    max-width: 1920px;

    .region {

      margin: 10px 0;
      flex: 1;

      p {
        text-indent: 1em;
      }

      p:hover {
        color: #ef3e2e
      }
    }

    .job {
      margin: 10px 0;
      margin-left: 30px;
      flex: 6;

      .info {
        position: relative;
        cursor: pointer;
        min-height: 80px;
        border: 1px solid #ccc;
        margin: 10px 0;
        text-align: center;
        line-height: 80px;

        .info_1 {
          text-align: left;
          font-weight: 500;
          margin-left: 30px;
        }

        .info_2 {
          font-size: 30px;
          position: absolute;
          top: 0;
          right: 30px;
          text-align: right;
          color: #ef3e2e;
          cursor: pointer;
        }

        .info_3 {
          padding-top: 10px;
          height: auto;
          background-color: #eee;
          line-height: 20px;
          padding-bottom: 16px;
          cursor: default;
          div {
            margin-left: 30px;
          }

          h3 {
            text-align: left;
            margin-left: 30px;
          }

          .p_1 {
            text-align: center;
            margin-top: 30px;
            margin-left: 30px;
            text-decoration: none;
            color: black;
          }

          p {
            margin: 0;
            padding: 0;
            text-align: left;
            margin-left: 30px;
            min-height: 40px;
            line-height: 35px;
          }
        }
      }
    }
  }
}

::v-deep .el-carousel {
  max-width: 1920px;
  margin: 0 auto;
  overflow-y: hidden;
  height: auto;
  max-height: 600px;
  // max-height: 700px;
}

::v-deep .el-carousel__container {
  height: 100% !important;
  min-height: 500px;
}

.el-carousel {
  max-width: 1920px;
  margin: 0 auto;
}

::v-deep .el-card {
  border-radius: 8px;
}

.images {
  width: 100%;
  height: 60autovh;
  max-height: 600px;
}

// 小屏幕区域
@media only screen and (min-width: 767px) {
  .box {
    display: block;
  }

  ._div {
    display: none;
  }
}

@media only screen and (max-width: 767px) {
  .box {
    display: none;
  }

  ._div {
    display: block;



    .content_center {
      padding: 30px;
      text-align: center;

      p {
        display: inline-block;
        margin-left: 50px;
        font-size: 70px;
        font-weight: 600;
        cursor: pointer;
        user-select: none;
      }

      .p_move {
        border-bottom: 8px solid #ef3e2e;
      }

      .info {
        width: 100%;
        height: auto;
        border: 1px solid #ccc;
        margin: 50px 0;
        min-height: 250px;
        cursor: pointer;

        .span_1,
        .span_2 {
          font-size: 60px;
          line-height: 250px;
        }

        .span_1 {
          float: left;
          margin-left: 100px;
        }

        .span_2 {
          float: right;
          font-size: 90px;
          margin-right: 100px;
          cursor: pointer;
          color: #ef3e2e;
        }

        .span_3 {
          background-color: #eee;
          margin-top: 230px;
          text-align: left;
          padding:  0 30px;
          box-sizing: border-box;
          padding-bottom: 30px;
          cursor: default;

          h3 {
            font-size: 60px;
            padding-top: 80px;
            text-align: center;
          }

          p {
            font-size: 45px;
            margin: 10px 0;
            text-align: left;
            font-weight: 400;
          }

          a {
            text-align: center;
            // margin-top: 30px;
            // margin-left: 30px;
            font-size: 60px;
            width: 1150px;
            height: 120px;
            line-height: 120px;
            border: 1px solid #ccc;
            text-decoration: none;
            color: black;
            margin-top: 10px;
            padding-bottom: 10px;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}
</style>